import { useSearchParams } from "react-router-dom";
import { MapPin, Users, PawPrint } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import EnquiryForm from "@/components/EnquiryForm";
import { IMG } from "@/data/content";

const INTEREST_MAP = {
  wedding: "Wedding",
  retreat: "Retreat",
  estate: "Full Estate Takeover",
};

export default function Enquire() {
  const [params] = useSearchParams();
  const interest = INTEREST_MAP[(params.get("interest") || "").toLowerCase()] || "Cottage Stay";

  return (
    <main data-testid="enquire-page">
      <section className="bg-[#1E1610] pb-14 pt-40 text-[#F4F1EA]">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
          <Reveal>
            <Eyebrow light>Enquire</Eyebrow>
            <h1 className="mt-4 max-w-3xl font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
              Tell us your dates and your dreams.
            </h1>
            <p className="mt-5 max-w-xl text-[#F4F1EA]/70">
              A cottage for two, a wedding weekend, a full-estate retreat — every enquiry is read personally, and we
              usually reply within a day or two.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16 lg:py-24">
        <div className="grid gap-14 lg:grid-cols-5 lg:gap-20">
          <Reveal className="lg:col-span-3">
            <EnquiryForm key={interest} defaultInterest={interest} />
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-2">
            <div className="overflow-hidden rounded-3xl">
              <img src={IMG.goat} alt="One of the resident FERAL Mowers" className="aspect-[4/3] w-full object-cover" />
            </div>
            <div className="mt-8 space-y-6">
              <div className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#5A4632] text-[#C89D56]">
                  <MapPin className="h-5 w-5" />
                </span>
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#B85D43]">Where</p>
                  <p className="mt-1 text-sm leading-relaxed text-[#241A12]">
                    Plas Llechylched, Rhosneigr, Isle of Anglesey, North Wales — surrounded by dog fields, with
                    beautiful sunset views.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#5A4632] text-[#C89D56]">
                  <Users className="h-5 w-5" />
                </span>
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#B85D43]">Capacity</p>
                  <p className="mt-1 text-sm leading-relaxed text-[#241A12]">
                    8 cottages + farmhouse · 20 bedrooms · sleeps up to 40.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#5A4632] text-[#C89D56]">
                  <PawPrint className="h-5 w-5" />
                </span>
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#B85D43]">The locals</p>
                  <p className="mt-1 text-sm leading-relaxed text-[#241A12]">
                    The FERAL Mowers approve all enquiries. Eventually.
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
